<template>
  <v-container class="system-role-add-page" fluid tag="section">
      <base-material-dialog
        :title='`考勤明细【${result.user !== undefined  ? result.user.name : ""}】`'
        :dialog="item.show"
        v-bind="$attrs"
        @on-dialog-change='dialogChange'
        max-width='1200'
        persistent
      >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-row>
            <v-col cols="12" md="2" v-for="(item, idx) in result.details" :key="idx">
              <v-card height="200" outlined v-if="item.workTime < new Date().getTime()/1000 - (60 * 60 * 24)" class="overflow-auto">
                <v-card-title class="size-12 pa-2 py-0">
                  {{item.workTime | formatDay}}
                  <v-spacer></v-spacer>
                  <v-chip dark label x-small class="pa-1" :color="item.work === 2 ? 'blue-grey' : 'green'">{{item.work === 2 ? '休' : '班'}}</v-chip>
                </v-card-title>
                <v-card-text class="px-2 pb-1">
                  <p class="white--text text-no-wrap grey font-weight-bold mb-1" v-if="result.user.detail.leaveTime && item.workTime > result.user.detail.leaveTime">
                    已离职
                  </p>

                  <div v-else>
                    <v-chip small class="pa-1 mr-1" label dark v-if="item.late === 1" color="red">
                      迟到
                    </v-chip>

                    <v-chip small class="pa-1 mr-1" label dark v-if="item.missing === 1" color="warning">
                      缺卡
                    </v-chip>

                    <v-chip small class="pa-1 mr-1" label dark v-if="item.businessDuration > 0" color="blue">
                      出差{{item.businessDuration}}天
                    </v-chip>

                    <v-chip small class="pa-1 mr-1" label dark v-if="item.travelDuration > 0" color="pink lighten-1">
                      请假{{item.travelDuration}}天
                    </v-chip>
                    <v-chip small class="pa-1 mr-1" label dark v-if="item.otDuration > 0" color="deep-purple lighten-3">
                      加班{{item.otDuration}}小时
                    </v-chip>
                    <v-chip small class="pa-1 mr-1" label dark v-if="item.leaveDuration > 0" color="indigo lighten-3">
                      调休{{item.leaveDuration}}天
                    </v-chip>
                    <v-chip small class="pa-1 mr-1" label dark v-if="item.needDayReport > 0 && item.dayReport === 0" color="pink lighten-3">
                      日报未提交
                    </v-chip>
                    <v-chip small class="pa-1 mr-1" label dark v-if="item.needWeekReport > 0 && item.weekReport === 0" color="pink lighten-3">
                      周报未提交
                    </v-chip>
                    <v-chip small class="pa-1 mr-1" label dark v-if="item.weekReport === 1 && item.needWeekReport == 0" color="pink lighten-3">
                      周报补交
                    </v-chip>

                    <v-chip small class="pa-1 mr-1" label dark v-if="item.callLack > 0" color="red">
                      通话缺{{item.callLack}}
                    </v-chip>

                    <div class="mt-3">
                      <div v-for="(h, index) in item.holidayInfoList" :key="`h-${index}`">
                        <div v-for="(m, ix) in h.mapList" :key="`m-${ix}`" class="white--text text-no-wrap orange lighten-1 mb-1 px-1">
                          <p class="my-0">{{m.text}}</p>
                          <p class="my-0">{{m.value.replace(" / ","至")}}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-3">
                    <div v-for="(i, index) in item.clockIns" :key="`i-${index}`" class="white--text text-no-wrap green mb-1 px-1">
                      {{i.checkInType === 1 ? '上班打卡：' : '下班打卡：'}}{{i.checkInTime | formatTime}}
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn small color="brown"
                    :disabled="item.repairAuditStatus === 0"
                    :dark="item.repairAuditStatus !== 0"
                    block rounded depressed
                    @click="repairModal = { show: true, type: 1, workTime: item.workTime }"
                    v-if="item.repairAuditStatus !== 1 && item.work === 1 && item.workTime >= result.user.detail.entryTime && $moment(item.workTime* 1000).diff($moment(result.user.detail.createTime * 1000), 'days') < 0">
                    {{ item.repairAuditStatus === 0 ? '补卡审核中...' : '入职补卡'}}
                  </v-btn>
                  <v-btn small color="primary" rounded depressed
                    :disabled="item.repairAuditStatus === 0"
                    :dark="item.repairAuditStatus !== 0"
                    @click="repairModal = { show: true, type: 2, workTime: item.workTime }"
                    v-if="item.missing === 1">
                    {{ item.repairAuditStatus === 0 ? '补卡审核中...' : '补卡'}}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
          </v-card-actions>
          <v-overlay :value="loading">
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>
        </v-card>
      </template>
    </base-material-dialog>
    <repair-view :item="repairModal" @on-load-data="workDetailByUid"></repair-view>
  </v-container>
</template>

<script>

  import { workDetailByUid } from '@/api/office/checkwork.js'
  import RepairView from './Repair.vue'

  export default {
    name: 'ClockIn',
    components: {
      RepairView
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        result: '',
        loading: false,
        repairModal: { show: false }
      }
    },
    methods: {
      workDetailByUid () {
        this.loading = true
        workDetailByUid(this.item.data).then(res => {
          if (res.status === 200) {
            this.result = res.data
          }
          this.loading = false
        })
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          this.workDetailByUid()
        }
      }
    }
  }
</script>
